// CAP-018 — riconosce la risposta «limite cantieri raggiunto» del backend.
//
// Il backend risponde 403 con un corpo strutturato (`backend/apps/cantieri/limiti.py`):
//   { codice: 'limite_cantieri', limite, titolo, testo, detail }
// Titolo e testo arrivano gia' composti dal CMS di AIstotele: il frontend li
// MOSTRA, non li riscrive. I testi qui sotto sono solo la rete se il corpo
// arriva senza (proxy, versione vecchia del backend): il messaggio non deve
// mai ridursi al JSON grezzo, che e' il difetto da cui nasce questa voce.

export const CODICE_LIMITE_CANTIERI = 'limite_cantieri';

export const TITOLO_DEFAULT = 'Non è stato possibile creare il cantiere';

export function testoDefault(limite) {
  var quanti = limite ? 'di ' + limite + ' ' : '';
  return 'Hai raggiunto il limite ' + quanti + 'cantieri attivi previsto dal piano Free. '
    + 'Per creare nuovi cantieri passa al piano a pagamento. In alternativa puoi '
    + 'archiviare un cantiere esistente per liberare spazio. Ricorda che al termine '
    + "dei 14 giorni di prova non potrai più accedere all'applicazione e ai dati salvati.";
}

// Ritorna { titolo, testo, limite } se l'errore e' il limite cantieri, altrimenti null.
export function limiteCantieriDaErrore(err) {
  var resp = err && err.response;
  if (!resp || resp.status !== 403) return null;
  var data = resp.data;
  if (!data || typeof data !== 'object' || data.codice !== CODICE_LIMITE_CANTIERI) return null;
  var limite = typeof data.limite === 'number' ? data.limite : null;
  return {
    limite: limite,
    titolo: (typeof data.titolo === 'string' && data.titolo.trim()) ? data.titolo : TITOLO_DEFAULT,
    testo: (typeof data.testo === 'string' && data.testo.trim()) ? data.testo : testoDefault(limite),
  };
}

// Destinazioni dei due pulsanti d'azione del modale.
export const ROTTA_PIANO = '/impostazioni#piano';
export const ROTTA_CANTIERI = '/cantieri';
